<template>
  <v-chart
    class="chart"
    ref="chartRef"
    :option="chartOption"
    :style="{ height: height + 'px' }"
    autoresize
  />
</template>

<script src="./model.js"></script>
<style src="./style.css" scoped></style>
